// extracted by mini-css-extract-plugin
module.exports = {"offices":"styles_offices__KoHUP","pulse":"styles_pulse__NyPTG","jump":"styles_jump__DhY6P","wiggle":"styles_wiggle__kHhyH"};